import axios from "axios";
import { headers_get } from "../tokens/get_headers_user";
import config from "../../config";

export async function paginatedApiCall(divnum, origen, options = {}) {
  const headers = await headers_get();

  const URL_MAPPINGS = {
    bp: { url: `${config?.URL_BUSINESS_PARTNERS}/od/business-partners?role=FACTURA&` },
    purchase: { url: `${config?.URL_PURCHASE}/od/purchase-orders?` },
    sectors: { url: `${config?.URL_BUSINESS_PARTNERS}/od/sectors?` },
    supplier_bp: { url: `${config?.URL_EXPENSES}/od/supplier-invoices?` },
  };

  const { url = config?.URL_BUSINESS_PARTNERS } = URL_MAPPINGS[origen] || {};

  try {
    // Obtener total de registros
    const totalResponse = await axios.get(url, { params: options, headers });
    const totalData = totalResponse?.data?.count || 0;

    if (!totalData) return [];

    // ✅ Si totalData es menor o igual a 500, hacer una sola petición
    if (totalData <= 500) {
      const { data } = await axios.get(`${url}offset=0&limit=${totalData}`, { params: options, headers });
      return data || [];
    }

    // Cálculo de paginación acumulativa
    const baseLimit = Math.floor(totalData / divnum);
    const extra = totalData % divnum;
    let results = [];
    let offset = 0;
    let accumulatedLimit = 0; // Aquí guardaremos el límite acumulado

    for (let i = 0; i < divnum; i++) {
      accumulatedLimit += baseLimit + (i < extra ? 1 : 0); // Aumentamos el límite acumulado
      const limit = accumulatedLimit; // Usamos el valor acumulado

      if (limit > 0) {
        try {
          const { data } = await axios.get(`${url}offset=${offset}&limit=${limit}`, { params: options, headers });
          results.push(...(data || []));
        } catch (err) {
          console.error(`Error en la paginación en offset ${offset}:`, err);
        }
      }

      offset = limit; // El offset ahora se mueve al límite acumulado
    }

    return results;
  } catch (error) {
    console.error("Error in paginatedApiCall:", error);
    return [];
  }
}
